<template>
  <div class="welcome">
    <div class="img-overlay-doctor"><img src="../assets/doctor-welcome2.png" alt=""></div>
    <div class="container">
      <div>
        <div class="intro-welcome" v-html="$t('welcome.titulo')"></div>
        <div v-if="loaded && getLanguage === 'es'" class="intro-buttons">
          <div><img src="../assets/buttons/get-app-android-es.svg" @click="goTo('android')" class="cursor-pointer" alt=""></div>
          <div><img src="../assets/buttons/get-app-ios-es.svg" @click="goTo('ios')" class="cursor-pointer" alt=""></div>
        </div>
        <div v-if="loaded && getLanguage !== 'es'" class="intro-buttons">
          <div><img src="../assets/buttons/get-app-android-en.svg" @click="goTo('android')" class="cursor-pointer" alt=""></div>
          <div><img src="../assets/buttons/get-app-ios-en.svg" @click="goTo('ios')" class="cursor-pointer" alt=""></div>
        </div>
      </div>
    </div>
    <div class="img-overlay-waves"><img src="../assets/waves-welcome.png" alt=""></div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import i18n from '../plugins/i18n.js'
export default {
  name: 'Welcome',
  props: {
    urlAndroid: String,
    urlIos: String
  },
  data: () => ({
    loaded: false
  }),
  computed: {
    getLanguage () {
      return i18n.locale
    }
  },
  methods: {
    goTo (type) {
      let url = ''
      if (type === 'android') {
        url = this.$store.state.urlAndroid
      }
      if (type === 'ios') {
        url = this.$store.state.urlIos
      }
      window.open(url, '_blank')
    }
  },
  mounted () {
    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
.welcome {
  position: relative;
  width: 100%;
  height: 900px;
  background: url(../assets/points-welcome.png) no-repeat #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .img-overlay-doctor {
    position: absolute;
    right: 75px;
    bottom: calc(50% - 240px);
    max-height: 644px;

    img {
      width: 140%;
    }
  }

  .img-overlay-waves {
    position: absolute;
    right: 0;
    bottom: -5px;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;

    > div {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .intro-welcome {
        margin-top: -50px;
        color: #444D67;
        font-weight: 800;
        font-size: 50px;
        line-height: 130%;
        text-align: left;
      }

      .intro-buttons {
        margin-top: 60px;
        display: flex;

        > div:first-of-type {
          margin-right: 40px;
        }
      }
    }
  }
}

@media(max-width: 1500px) {
  .welcome {
    height: 770px;

    .container > div .intro-welcome {
      font-size: 45px;
    }

    .img-overlay-doctor {
      right: 0;
      bottom: calc(50% - 300px);
      max-height: 610px;
      max-width: 600px;

      img {
        width: 130%;
      }
    }
  }
}

@media(max-width: 1200px) {
  .welcome {
    height: 725px;

    .container > div .intro-welcome {
      font-size: 40px;
    }

    .img-overlay-doctor {
      max-width: 50%;
      text-align: right;
      right: -50px;

      img {
        width: 120%;
      }
    }
  }
}

@media(max-width: 940px) {
  .welcome {
    height: 615px;

    .container > div .intro-welcome {
      font-size: 32px;
    }

    .container > div .intro-buttons {
      margin-top: 45px;

      div:first-of-type {
        margin-right: 25px;
      }

      img {
        height: 55px;
      }
    }

    .img-overlay-doctor {
      bottom: calc(50% - 240px);
    }
  }
}

@media(max-width: 800px) {
  .welcome {
    height: 615px;

    .container > div {
      width: 60%;

      .intro-welcome {
        font-size: 28px;
      }

      .intro-buttons {
        margin-top: 35px;

        div:first-of-type {
          margin-right: 20px;
        }
      }
    }

    .img-overlay-doctor {
      bottom: calc(50% - 220px);

      img {
        max-width: 115%;
        margin-right: -160px;
      }
    }
  }
}

@media(max-width: 700px) {
  .welcome {
    .img-overlay-doctor {
      display: none;
    }

    .container > div {
      width: 100%;
  }
  }
}

@media(max-width: 650px) {
  .welcome {
    height: 515px;

    .container > div .intro-buttons img {
      height: 55px;
    }
  }
}

@media(max-width: 500px) {
  .welcome {
    .container > div .intro-buttons img {
      height: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/welcome.vue